export default {
	//@ts-ignore
	install(Vue, options) {
		Vue.mixin({
			methods: {
				//@ts-ignore
				Round(num, d) {
					var decimalPlaces = Math.pow(10, d);
					return Math.round((num + Number.EPSILON) * decimalPlaces) / decimalPlaces;
				},
				//@ts-ignore
				Format(num) {
					return new Intl.NumberFormat(navigator.language, { minimumFractionDigits: 3, }).format(num);
				},
				//@ts-ignore
				Average(nums) {
					//@ts-ignore
					return nums.reduce((acc, n) => acc + n, 0);
				}
			},
			mounted() {
				Vue.prototype.$math = {
					round: this.Round,
					format: this.Format
				}
			}
		});
	}
}
